import {Component, Input, OnChanges, ChangeDetectionStrategy} from "@angular/core";

// renders a loading placeholder that mirrors the real ptp grid: the same table + column headers for
// the active tab (Request / PO / Dashboard) with nz-skeleton bars standing in for the row cells.
// keeping the identical table structure means no layout shift when the real rows arrive.
@Component({
    selector: "app-ptp-grid-skeleton",
    templateUrl: "./ptp-grid-skeleton.component.html",
    styleUrls: ["./ptp-grid-skeleton.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PtpGridSkeletonComponent implements OnChanges {
    // SelectedType from the ptp grid: 0 = Request, 1 = PO, 3 = Dashboard
    @Input() type = 0;
    @Input() stepName = "";
    @Input() showCanceled = false;
    @Input() rows = 8;

    // precomputed backing data (no function calls in the template)
    headers: string[] = [];
    rowRange: number[] = [];

    ngOnChanges(): void {
        this.headers = this.buildHeaders();
        const count = Math.min(Math.max(this.rows || 8, 3), 12);
        this.rowRange = Array.from({length: count}, (_, i) => i);
    }

    private buildHeaders(): string[] {
        const isGoodsReceipt = this.stepName === "Goods Receipt";

        switch (this.type) {
            case 1: // Purchase Orders
                return [
                    "", // select checkbox
                    "Actions",
                    "PO Date",
                    "PO #",
                    "Vendor Name",
                    "Due Date",
                    ...(isGoodsReceipt ? ["Received"] : []),
                    "Invoice #",
                    "Items",
                    "Total"
                ];
            case 3: // Dashboard
                return [
                    ...(this.showCanceled ? ["Actions"] : []),
                    "Type",
                    "Step",
                    "Requested By",
                    "Date",
                    "PO #",
                    "Request #",
                    "Vendor Name",
                    "Location",
                    "Due Date",
                    "Invoice #",
                    "Items",
                    "Total"
                ];
            default: // 0 = Purchase Requests
                return [
                    "", // select checkbox
                    "Actions",
                    "Requested By",
                    "Request Date",
                    "Request #",
                    "Vendor Name",
                    "Items",
                    "Total"
                ];
        }
    }
}
